import { userUnlink } from "api/user";
import { notifySimple } from "providers/toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLoading } from "store/appSlice";
import ProfileCard from "widgets/cards/profile";
import GenericButton from "widgets/controls/buttons/generic";
import { useNotificationDialog } from "providers/notification-dialog-provider";
import { useTranslation } from "react-i18next";

const Delete = ({ email = "" }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { notify } = useNotificationDialog();

  const doUnlink = async () => {
    dispatch(setLoading(true));
    const { error, isLoading, status } = await userUnlink(email);
    dispatch(setLoading(isLoading));

    if (status === 200) {
      notifySimple(t("notification.success"), "success");
      navigate("/admin/users", { replace: true });
    } else {
      notifySimple(error, "error");
    }
  };

  return (
    <>
      <ProfileCard
        title={t("dialog.user.unlink.title")}
        description={t("dialog.user.unlink.description")}
        bgColor="bg-background-200"
        textColor="text-white"
        textDescriptionColor="text-white"
        extra="h-full"
      >
        <div className="flex h-full w-full flex-col">
          <div className="flex-grow"></div>
          <div className="flex justify-end">
            <GenericButton
              variant="outline"
              size="md"
              text={t("button.action.unlink")}
              onClick={() => {
                notify({
                  header: t("dialog.warning.title"),
                  message: t("dialog.user.unlink.message"),
                  okText: t("button.action.unlink"),
                  cancelText: t("button.action.cancel"),
                  onOk: doUnlink,
                  onCancel: () => {},
                });
              }}
              color="white"
            />
          </div>
        </div>
      </ProfileCard>
    </>
  );
};

export default Delete;
